import { styled } from "theme/default/styled";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SFetchedFilterMultipleSelect = styled.div`
  width: 240px;

  ${setFlexDFFDC};
`;
